/**
 * SJCAM: naprawa "migania" menu głównego.
 *
 * Gdy kursor przechodzi z jednej pozycji paska menu na drugą, zdarzenie
 * pointerleave poprzedniej pozycji potrafi dotrzeć już po otwarciu nowej
 * i zamknąć ją (komponent zamyka aktualnie aktywną pozycję, a nie tę, którą
 * kursor opuścił). Ignorujemy opuszczenie pozycji, która nie jest rozwinięta.
 */
const patchHeaderMenu = () => {
  const HeaderMenu = customElements.get('header-menu');
  if (!HeaderMenu || HeaderMenu.prototype.__sjcamLeaveFix) return;

  const originalDeactivate = HeaderMenu.prototype.deactivate;

  HeaderMenu.prototype.deactivate = function (event) {
    const target = event && event.target;

    if (target instanceof Element && event.type === 'pointerleave') {
      const link = target.querySelector(':scope > [ref="menuitem"]');
      if (link && link.getAttribute('aria-expanded') !== 'true') return;
    }

    return originalDeactivate.call(this, event);
  };

  HeaderMenu.prototype.__sjcamLeaveFix = true;
};

if (customElements.get('header-menu')) {
  patchHeaderMenu();
} else {
  customElements.whenDefined('header-menu').then(patchHeaderMenu);
}
